export default function (value) {
  if (typeof value != "string") return "NOT A STRING";

  return value.toLowerCase();
}
